export default {"src":"/oferta/_next/static/media/logo.63c38c12.svg","height":24,"width":133,"blurWidth":0,"blurHeight":0};